import { ThemedStyleFn } from '~src/hooks/useStyles';
import { fadeInKeyframes } from '~src/styles/animations';

export const styleFn: ThemedStyleFn = (theme) => ({
  container: {
    display: ' flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    position: 'relative',
    justifyContent: 'space-between',
  },
  panelsContainer: {
    position: 'absolute',
    left: 0,
    bottom: 0,
    width: '100%',
  },
  divider: {
    padding: '0 20px',
  },
  row: {
    display: ' flex',
    flexDirection: 'row',
    marginLeft: '15px',
  },
  column: {
    display: ' flex',
    flexDirection: 'column',
  },
  icons: {
    color: theme.colors.secondary,
    fontSize: '40px',
    margin: '0 6px',
  },
  blue: {
    color: theme.colors.primary,
  },
  grayBlue: {
    color: '#184a9a',
  },
  red: {
    color: theme.colors.red,
  },
  green: {
    color: theme.colors.green,
  },
  darkGray: {
    color: theme.colors.darkGray,
  },
  yellow: {
    color: theme.colors.yellow,
  },
  small: {
    fontSize: '16px',
  },
  info: {
    padding: '10px 40px',
  },
  projectInfo: {
    display: 'flex',
  },
  projectName: {
    padding: '10px 15px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },

  detailsGrid: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '12px 30px', // Row gap, Column gap
    padding: '20px 20px 0 20px',
    alignItems: 'start',
  },
  detailItem: {
    display: 'grid',
    //label width (140px) to align all values vertically, rest is value
    gridTemplateColumns: '140px 1fr',
    columnGap: '10px',
    alignItems: 'baseline',
    width: '100%',

    '& p': {
      margin: 0,
      minWidth: 0,
      wordBreak: 'break-word',
      overflowWrap: 'anywhere',
    },
  },

  containerProjectData: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: '100%',
    flexWrap: 'wrap',
  },
  leftColumn: {
    flex: 1,
    minWidth: '300px',
    padding: '20px',
  },
  rightColumn: {
    flex: 1,
    padding: '20px',
    minWidth: '300px',
  },
  companyInfo: {
    marginTop: '30px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    padding: '10px 20px',
    alignSelf: 'flex-end',
  },
  companyLogo: {
    width: '200px',
    marginBottom: '10px',
  },
  companyDetails: {
    textAlign: 'right',
  },
  labelCss: {
    margin: 0,
    whiteSpace: 'nowrap',
    fontWeight: 'bold',
  },
  valueCss: {
    margin: 0,
    minWidth: 0,
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
  },
  welcomeContainer: {
    padding: '40px 20px',
    maxWidth: '600px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    animation: `${fadeInKeyframes} 0.5s ease-in-out`,
  },
  welcomeText: {
    fontSize: '16px',
    color: theme.colors.darkGray,
    whiteSpace: 'pre-line',
    lineHeight: '1.6',
  },
});
